import React, { useEffect } from "react";
import ModalContainer from "../../Components/Modal/ModalContainer";
import { useFormik } from "formik";
import * as yup from "yup";
import { FormHeading } from "../../Layouts/Heading";
import { Grid, InputLabel, Switch, TextField } from "@mui/material";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { useDispatch, useSelector } from "react-redux";
import {
    CreateNewBusiness,
    getAllBusiness,
    resetBusiness,
} from "../../Redux/BusSlice/BusSlice";
import { toast } from "react-toastify";

const validationSchema = yup.object({
    title: yup.string("Enter your title").required(" title is required "),
    initial: yup.string("Enter your initial").required("initial is required"),
});

const CreateBusiness = () => {
    const dispatch = useDispatch();
    const { isBusSuccess, isBusError, isBusLodaing, Busmassage } = useSelector(
        (state) => state.business
    );

    const formik = useFormik({
        initialValues: {
            title: "",
            initial: "",
            is_active: false,
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await dispatch(CreateNewBusiness(values));
            await dispatch(resetBusiness());
        },
    });

    useEffect(() => {
        if (isBusError) {
            toast.error(Busmassage);
        }
        if (
            isBusSuccess &&
            formik.values.title != null &&
            formik.values.initial
        ) {
            formik.values = {
                title: null,
                initial: null,
                is_active: false,
            };
            toast.success("Created successfully");
        }
        dispatch(resetBusiness());
    }, [isBusError, Busmassage, isBusSuccess]);

    return (
        <>
            <ModalContainer>
                <FormHeading>Add a New Business </FormHeading>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item mb={2} xs={12} md={6}>
                            <TextField
                                fullWidth
                                id="title"
                                name="title"
                                label="title"
                                value={formik.values.title}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.title &&
                                    Boolean(formik.errors.title)
                                }
                                helperText={
                                    formik.touched.title && formik.errors.title
                                }
                            />
                        </Grid>
                        <Grid item mb={2} xs={12} md={6}>
                            <TextField
                                fullWidth
                                id="initial"
                                name="initial"
                                label="Initial"
                                value={formik.values.initial}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.initial &&
                                    Boolean(formik.errors.initial)
                                }
                                helperText={
                                    formik.touched.initial &&
                                    formik.errors.initial
                                }
                            />
                        </Grid>
                        <Grid item mb={1} xs={12} md={6}>
                            <InputLabel> Active ? </InputLabel>
                            <Switch
                                id="is_active"
                                name="is_active"
                                checked={formik.values.is_active}
                                onChange={formik.handleChange}
                                inputProps={{ "aria-label": "controlled" }}
                            />
                        </Grid>
                    </Grid>

                    <PrimaryButton fullWidth type="submit">
                        {isBusLodaing ? "Loading..." : "Create"}
                    </PrimaryButton>
                </form>
            </ModalContainer>
        </>
    );
};

export default CreateBusiness;
